import React from "react";
import InputFieldForLots from "../offerComponents/InputFieldForLots";


function SelectContract({ setCreateOffer, auctionDetails }) {
    return (
        <div className="pin-top" style={{ marginRight: "0.3rem" }}>
            <InputFieldForLots
                label={"Contract Validation"}
                type={"number"}
                name={"contractValidity"}
                value={auctionDetails?.contractValidity}
                placeholder={"Enter days"}
                setCreateOffer={setCreateOffer}
            />
        </div>
    );
}

export default SelectContract;
